import { EffectCallback, useEffect } from 'react';

/** @deprecated */
export const useMountEffect = (cb: EffectCallback) =>
  useEffect(() => {
    cb();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
